import {inject, Injectable} from '@angular/core';
import {ToggleGroupAllVisibilityParams} from "../../types/table-types/toggle-group-all-visibility.types";
import {UserPreferencesService} from "../user-preferences.service";
import {ColumnParamsStateService} from "./column-params-state.service";

@Injectable({
  providedIn: 'root'
})
export class ToggleAllGroupsVisibilityService {
  private userPreferencesService: UserPreferencesService = inject(UserPreferencesService);
  private columnParamsStateService: ColumnParamsStateService = inject(ColumnParamsStateService);

  public toggleGroupAllVisibility(toggleGroupAllVisibilityParams: ToggleGroupAllVisibilityParams): void {
    const { key, action } = toggleGroupAllVisibilityParams;
    const columnParams = this.columnParamsStateService.getColumnParamsByKey(key);
    if (!columnParams?.length) { return; }

    const hiddenGroups = this.userPreferencesService.getUserPreferences()?.hiddenGroupsKeys;

    switch (action) {
      case 'EXPAND_GROUP':
        if (!hiddenGroups?.length) { return; }

        this.columnParamsStateService.updateAllHiddenGroups(toggleGroupAllVisibilityParams);
        this.userPreferencesService.saveUserPreferences({ hiddenGroupsKeys: [] });
        break;
      case 'COLLAPSE_GROUP':
        const allGroupIds = new Set<string>(
          columnParams
            .map(column => !column.hiddenColumn && column.columnProperties.GROUP?.id)
            .filter((id): id is string => id !== undefined)
        );
        const visibleGroupIds = [...allGroupIds].filter(groupId => !hiddenGroups?.includes(groupId));
        if (!visibleGroupIds.length) { return; }

        this.columnParamsStateService.updateAllHiddenGroups(toggleGroupAllVisibilityParams);
        this.userPreferencesService.saveUserPreferences({ hiddenGroupsKeys: [...allGroupIds] });
        break;
    }
  }
}
